import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTruck = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="currentColor"><path d="M0 4.171v19.922h4.109a4.27 4.27 0 0 1 8.342 0h6.226V4.171zm27.654 12.227-1.344-3.51h-5.53v11.205h1.133a4.457 4.457 0 0 1 8.505 0H32v-6.462z" /><path d="M8.293 22.848a2.49 2.49 0 1 0 0 4.98 2.49 2.49 0 0 0 0-4.98zm17.855 0a2.49 2.49 0 1 0 0 4.98 2.49 2.49 0 0 0 0-4.98z" /></g></svg>;
export default SvgTruck;